export default __webpack_public_path__ + "static/media/icon-close-red-xl.b37b4815.svg";